import axios from 'axios'
import { DEFAULT_ERROR_MESSAGE, FORBIDDEN_ERROR_MESSAGE, SERVER_ERROR_MESSAGE } from '../../shared/static/constants.static'
import DialogUtils from '../../views/utils/dialog.utils'


class ErrorsUtil {
    public static manageError = async (error: any) => {
        // Si es null o no es un error relacionado con axios (cualquier error de JS o runtime error)
        if (!error || !axios.isAxiosError(error)) {
            DialogUtils.showErrorDialog(DEFAULT_ERROR_MESSAGE)
            return
        }

        // En caso de no haber recibido repuesta alguna del api
        if (error.request && !error.response) {
            DialogUtils.showErrorDialog(DEFAULT_ERROR_MESSAGE)
            return
        }

        if (error.response?.status && error?.response?.status === 403) {
            DialogUtils.showErrorDialog(FORBIDDEN_ERROR_MESSAGE)
            return
        }

        // Si hay respuesta del servidor
        if (error.response?.status && error?.response?.status >= 400 && error?.response?.status <= 499) {
            DialogUtils.showErrorDialog(SERVER_ERROR_MESSAGE)
            return
        }

        DialogUtils.showErrorDialog(DEFAULT_ERROR_MESSAGE)
    }
}

export default ErrorsUtil
